/**
 * KAN-868: что из настройки приложения менеджера ещё не сделано, для строки
 * пометок сверху вкладок /m (KAN-873: MobileSetupChips, lib/managerSetupChips.ts). Правила "сделано / показывать" общие
 * с шагами "push" и "telegram" экрана "Начало работы" (предикаты из
 * lib/managerOnboarding.ts); здесь только то, какую подсказку дать по PushView.
 * Установки, телефона и пароля здесь нет: телефон добавляет lib/managerSetupChips.ts (KAN-837).
 */
import type { PushView } from '@/hooks/usePushSubscription';
import { isPushDone, isPushUnavailable, isTelegramPending, type TelegramLinkState } from '@/lib/managerOnboarding';

/** Что показать в пункте про уведомления: кнопку, подсказку iOS или как разрешить. */
export type PendingPush = 'enable' | 'ios-install' | 'denied';

export interface SetupPending {
  push: PendingPush | null;
  telegram: boolean;
}

export interface SetupPendingInputs {
  pushView: PushView;
  /** null: статус уведомлений неизвестен (грузится или ошибка), пункта Telegram нет. */
  telegram: TelegramLinkState;
}

const PUSH_HINT: Record<Exclude<PushView, 'loading' | 'on' | 'unsupported'>, PendingPush> = {
  off: 'enable',
  'ios-install': 'ios-install',
  denied: 'denied',
};

function pendingPush(view: PushView): PendingPush | null {
  // loading: ещё неизвестно; on: сделано; unsupported: менеджер ничего не может сделать.
  if (view === 'loading' || isPushDone(view) || isPushUnavailable(view)) return null;
  return PUSH_HINT[view as keyof typeof PUSH_HINT] ?? null;
}

export function getSetupPending({ pushView, telegram }: SetupPendingInputs): SetupPending {
  return {
    push: pendingPush(pushView),
    telegram: isTelegramPending(telegram),
  };
}

export function hasSetupPending(pending: SetupPending): boolean {
  return pending.push !== null || pending.telegram;
}
